import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import LinearProgress from "@mui/material/LinearProgress";
import { CustomPagination, CustomNoRowsOverlay } from "../SecondaryFunctions";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const pageHeight = `calc(100vh - calc(11rem + 8px))`;

const centerCell = (params) => (
  <div className="flex items-center justify-center h-full w-full text-center">
    {params.value}
  </div>
);

const columns = [
  {
    field: "empid",
    headerName: "EMPID",
    flex: 0.7,
    minWidth: 70,
    align: "center",
    headerAlign: "center",
    renderCell: centerCell,
  },
  {
    field: "ccid",
    headerName: "CCID",
    flex: 0.8,
    minWidth: 75,
    align: "center",
    headerAlign: "center",
    renderCell: centerCell,
  },
  {
    field: "name",
    headerName: "NAME",
    flex: 1.2,
    minWidth: 110,
    align: "center",
    headerAlign: "center",
    renderCell: centerCell,
  },
  {
    field: "role",
    headerName: "ROLE",
    flex: 1.2,
    minWidth: 110,
    align: "center",
    headerAlign: "center",
    renderCell: centerCell,
  },
  {
    field: "dname",
    headerName: "DEPARTMENT",
    flex: 1.4,
    minWidth: 130,
    align: "center",
    headerAlign: "center",
    renderCell: centerCell,
  },
  {
    field: "fname",
    headerName: "FACULTY",
    flex: 2.4,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
    renderCell: centerCell,
  },
  {
    field: "comment_editing",
    headerName: "COMMENT REDACTING",
    flex: 0.9,
    minWidth: 105,
    align: "center",
    headerAlign: "center",
    renderCell: centerCell,
  },
  {
    field: "created_by",
    headerName: "CREATED BY",
    flex: 1.2,
    minWidth: 110,
    align: "center",
    headerAlign: "center",
    renderCell: centerCell,
  },
  {
    field: "created_on",
    headerName: "CREATED ON",
    flex: 1.2,
    minWidth: 110,
    align: "center",
    headerAlign: "center",
    renderCell: centerCell,
  },
];

const roleOptions = [
  "Dean",
  "Dean Acting",
  "Dean Assoc",
  "Interim Dean",
  "Department Chair",
  "Department Coordinator",
  "Comment Redacting Designee",
  "Report Designee",
  "DDC Designee",
];

export default function UpdateDDCs() {
  const [loaded, setLoaded] = useState(false);
  const [ddcData, SetDdcData] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [faculties, setFaculties] = useState([]);
  const [taskType, setTaskType] = useState(null);
  const [ddcFormWindow, setDdcFormWindow] = useState(false);
  const [ddcFormData, setDdcFormData] = useState({});
  const [updateLoading, setUpdateLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState(null);
  const [updatedFields, SetUpdatedFields] = useState(false);

  const validDDCentry =
    ddcFormData.length !== 0 &&
    ddcFormData.empid &&
    ddcFormData.ccid &&
    ddcFormData.firstName &&
    ddcFormData.lastName &&
    // ddcFormData.faculty &&
    ddcFormData.dept_id &&
    ddcFormData.role &&
    ddcFormData.comment_editing &&
    (!ddcFormData.role.toLowerCase().includes("dean") ||
      ddcFormData.faculty != null) &&
    updatedFields;

  useEffect(() => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const url = process.env.REACT_APP_BACKEND_HOST;

    async function collect_ddc_table() {
      const response = await fetch(`${url}/spot/view_ddc_table/`, {
        headers: { Authorization: `Token ${sessionStorage.token}` },
      });

      const apiData = await response.json();

      const formatedData = apiData.map((row, index) => {
        const add_date = new Date(row.CREATION_DATE);
        const nameParts = row.NAME.split(",");
        const lastName = nameParts[0]?.trim() || "";
        const firstName = nameParts[1]?.trim() || "";
        return {
          id: index,
          ddc_id: row.DDC_ID,
          empid: row.EMPID,
          ccid: row.CCID,
          name: `${firstName} ${lastName}`.trim(),
          role: row.ROLE,
          dept_id: row.DEPT_ID,
          dname: row.DNAME,
          faculty: row.FACULTY,
          fname: row.FNAME || "N/A",
          comment_editing: row.COMMENT_EDITING,
          created_by: `${row.CREATED_BY}@ualberta.ca`,
          created_on: `${monthNames[add_date.getMonth()]} ${add_date.getDate()}, ${add_date.getFullYear()}`,
        };
      });

      setTimeout(() => {
        SetDdcData(formatedData);
        setLoaded(true);
      }, 1000);
    }

    async function fetch_departments() {
      const response = await fetch(`${url}/spot/fetch_departments/`, {
        headers: { Authorization: `Token ${sessionStorage.token}` },
      });

      const apiData = await response.json();
      setDepartments(apiData);
    }

    async function fetch_faculties() {
      const response = await fetch(`${url}/spot/fetch_faculties/`, {
        headers: { Authorization: `Token ${sessionStorage.token}` },
      });

      const apiData = await response.json();
      setFaculties(apiData);
    }

    if (!loaded) {
      collect_ddc_table();
      fetch_departments();
      fetch_faculties();
    }
  }, [loaded]);

  const openDDCform = () => {
    setDdcFormWindow(true);
  };

  const closeDDCform = () => {
    setDdcFormData({});
    setDdcFormWindow(false);
  };

  const setInsertTaskType = () => {
    setTaskType("INSERT");
    openDDCform();
  };

  const setUpdateTaskType = (row) => {
    setTaskType("UPDATE");
    collectDDCdata(row);
    openDDCform();
  };

  const collectDDCdata = (row) => {
    const [firstName = "", lastName = ""] = row.name.split(" ");
    const data = {
      ddc_id: row.ddc_id,
      ccid: row.ccid,
      empid: row.empid,
      firstName: firstName,
      lastName: lastName,
      dept_id: row.dept_id,
      faculty: row.faculty,
      role: row.role,
      comment_editing: row.comment_editing,
    };
    setDdcFormData(data);
  };

  const uploadDDCdata = (field, value) => {
    setDdcFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    SetUpdatedFields(true);
  };

  async function updateDDCtable() {
    setUpdateLoading(true);

    const api_data = {
      ...ddcFormData,
      taskType: taskType,
      user: sessionStorage.ccid,
    };

    const response = await fetch(
      process.env.REACT_APP_BACKEND_HOST.concat("/spot/update_ddc_table/"),
      {
        method: "PUT",
        headers: {
          Authorization: `Token ${sessionStorage.token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(api_data),
      },
    );
    const insert_status = await response.json();

    setUpdateLoading(false);
    if (insert_status.status === 200) {
      setStatusMessage("SUCCESS");
    } else {
      setStatusMessage("ERROR");
    }

    setTimeout(() => {
      closeDDCform();
      setLoaded(false);
      setStatusMessage(null);
    }, 2000);
    SetUpdatedFields(false);
  }

  return (
    <Box
      sx={{
        py: 2,
        px: 4,
        height: pageHeight,
        backgroundColor: "#f5f5f5",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center", // vertical centering
        alignItems: "center", // horizontal centering
        gap: 2,
      }}
    >
      <DataGrid
        // getRowHeight={() => "auto"}
        rowHeight={72}
        columns={columns}
        rows={ddcData}
        onRowDoubleClick={(params) => {
          setUpdateTaskType(params.row);
        }}
        pageSize={100}
        rowsPerPageOptions={[100]}
        density={"compact"}
        loading={!loaded}
        slots={{
          Pagination: CustomPagination,
          LoadingOverlay: LinearProgress,
          NoRowsOverlay: CustomNoRowsOverlay,
        }}
        sx={{
          flex: 1,
          width: "100%",

          "& .MuiDataGrid-main": {
            overflow: "hidden",
          },

          "& .MuiDataGrid-cell": {
            whiteSpace: "normal",
            lineHeight: "1.25rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            py: 0.5,
          },

          "& .MuiDataGrid-columnHeader": {
            whiteSpace: "normal",
          },

          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
            whiteSpace: "normal",
            lineHeight: "1.1rem",
            textAlign: "center",
          },
        }}
      />

      <Button
        onClick={setInsertTaskType}
        variant="contained"
        sx={{
          width: "30%",
          fontWeight: 500,
          "& .MuiOutlinedInput-root": {
            borderRadius: 1,
          },
        }}
      >
        INSERT NEW DDC
      </Button>

      <Dialog
        class="Form Window"
        open={ddcFormWindow}
        fullWidth={true}
        maxWidth={"lg"}
      >
        <DialogContent
          sx={{
            // paddingBottom:4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            // gap: 4,
            // border: "2px solid rgba(255, 0, 0, 1)",
          }}
        >
          <DialogTitle id="alert-dialog-title">DDC RECORD ENTRY</DialogTitle>

          <IconButton
            aria-label="close"
            onClick={closeDDCform}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>

          {updateLoading && statusMessage === null && (
            <CircularProgress
              enableTrackSlot
              color="primary"
              size={50}
              thickness={5}
            />
          )}
          {!updateLoading && statusMessage === null && (
            <Box
              sx={{
                paddingBottom: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 4,
                width: "100%",
                // border: "2px solid rgba(255, 0, 0, 1)",
              }}
            >
              <Box
                name="EMPID and CCID"
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 2,
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "40%",
                    gap: 1,
                  }}
                >
                  <TextField
                    id="empid"
                    type="text"
                    name="empid"
                    label="EMPID"
                    value={ddcFormData.empid || ""}
                    // onChange={uploadDDCdata}
                    onChange={(e) => {
                      const onlyNumbers = e.target.value.replace(/\D/g, "");
                      uploadDDCdata("empid", onlyNumbers);
                    }}
                    inputProps={{
                      maxLength: 10,
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                    }}
                    fullWidth
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1,
                      },
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "40%",
                    gap: 1,
                  }}
                >
                  <TextField
                    id="ccid"
                    type="text"
                    name="ccid"
                    label="CCID"
                    value={ddcFormData.ccid || ""}
                    onChange={(e) => {
                      uploadDDCdata("ccid", e.target.value);
                    }}
                    inputProps={{
                      maxLength: 15,
                    }}
                    fullWidth
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1,
                      },
                    }}
                  />
                </Box>
              </Box>

              <Box
                name="FIRST AND LAST NAME"
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 2,
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "40%",
                    gap: 1,
                  }}
                >
                  <TextField
                    id="firstName"
                    type="text"
                    name="firstName"
                    label="FIRST NAME"
                    value={ddcFormData.firstName || ""}
                    onChange={(e) => {
                      uploadDDCdata("firstName", e.target.value);
                    }}
                    inputProps={{
                      maxLength: 20,
                      inputMode: "text",
                      pattern: "[a-zA-Z]*",
                    }}
                    fullWidth
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1,
                      },
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "40%",
                    gap: 1,
                  }}
                >
                  <TextField
                    id="lastName"
                    type="text"
                    name="lastName"
                    label="LAST NAME"
                    value={ddcFormData.lastName || ""}
                    onChange={(e) => {
                      uploadDDCdata("lastName", e.target.value);
                    }}
                    inputProps={{
                      maxLength: 20,
                      inputMode: "text",
                      pattern: "[a-zA-Z]*",
                    }}
                    fullWidth
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1,
                      },
                    }}
                  />
                </Box>
              </Box>

              <Box
                name="FACULTY"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  alignItems: "center",
                  // gap: 1,
                  // border: "2px solid rgba(255, 0, 0, 1)"
                }}
              >
                <Autocomplete
                  size="small"
                  options={faculties}
                  value={
                    faculties.find(
                      (entry) => entry.faculty === ddcFormData.faculty,
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    uploadDDCdata(
                      "faculty",
                      newValue ? newValue.faculty : null,
                    );
                  }}
                  getOptionLabel={(option) => option?.fname || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.faculty === value.faculty
                  }
                  sx={{ width: "calc(80% + 16px)" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="FACULTY"
                      sx={{ backgroundColor: "#fff" }}
                    />
                  )}
                />
              </Box>

              <Box
                name="DEPARTMENT"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  alignItems: "center",
                  // gap: 1,

                  // border: "2px solid rgba(255, 0, 0, 1)"
                }}
              >
                <Autocomplete
                  size="small"
                  options={departments}
                  value={
                    departments.find(
                      (entry) => entry.dept_id === ddcFormData.dept_id,
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    uploadDDCdata(
                      "dept_id",
                      newValue ? newValue.dept_id : null,
                    );
                  }}
                  getOptionLabel={(option) => option?.display_name || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.dept_id === value.dept_id
                  }
                  sx={{ width: "calc(80% + 16px)" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="DEPARTMENT"
                      sx={{ backgroundColor: "#fff" }}
                    />
                  )}
                />
              </Box>

              <Box
                name="ROLE"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  alignItems: "center",
                  // gap: 1,
                  // border: "2px solid rgba(255, 0, 0, 1)"
                }}
              >
                {/* <TextField
                                        id="role"
                                        type="text"
                                        name="role"
                                        label="ROLE"
                                        value={ddcFormData.role || ""}
                                        onChange={(e) => {uploadDDCdata("role",e.target.value)}}
                                        inputProps={{
                                            maxLength: 50,
                                        }}
                                        fullWidth
                                        size="small"
                                        sx={{
                                            width: "calc(80% + 16px)",
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: 1,
                                            },
                                        }}
                                    /> */}

                <Autocomplete
                  size="small"
                  options={roleOptions}
                  value={ddcFormData.role || ""}
                  onChange={(event, newValue) => {
                    uploadDDCdata("role", newValue);
                  }}
                  // getOptionLabel={(option) => option?.display_name || ""}
                  // isOptionEqualToValue={(option, value) => option.dept_id === value.dept_id}
                  sx={{ width: "calc(80% + 16px)" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="ROLE"
                      sx={{ backgroundColor: "#fff" }}
                    />
                  )}
                />
              </Box>

              <FormControl
                sx={{
                  width: "calc(80% + 16px)",
                  position: "relative",
                  border: "1px solid rgba(0, 0, 0, 0.23)",
                  borderRadius: "4px",
                  backgroundColor: "#fff",
                  px: 1.5,
                  pt: 1.5,
                  pb: 0.5,

                  "&:hover": {
                    borderColor: "rgba(0, 0, 0, 0.87)",
                  },
                }}
              >
                <FormLabel
                  sx={{
                    position: "absolute",
                    top: "-9px",
                    left: "12px",
                    px: "4px",
                    backgroundColor: "#fff",
                    fontSize: "0.75rem",
                    lineHeight: 1,

                    color: "rgba(0, 0, 0, 0.6)",

                    "&.Mui-focused": {
                      color: "rgba(0, 0, 0, 0.6)",
                    },
                  }}
                >
                  COMMENT REDACTING
                </FormLabel>
                <RadioGroup
                  row
                  value={ddcFormData.comment_editing || null}
                  onChange={(e) => {
                    uploadDDCdata("comment_editing", e.target.value);
                  }}
                  sx={{
                    justifyContent: "center",
                  }}
                >
                  <FormControlLabel value="Y" control={<Radio />} label="Yes" />
                  <FormControlLabel value="N" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>

              {taskType === "INSERT" && (
                <Button
                  disabled={!validDDCentry}
                  onClick={updateDDCtable}
                  variant="contained"
                  sx={{
                    width: "50%",
                    fontWeight: 500,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 1,
                    },
                  }}
                >
                  INSERT NEW DDC RECORD
                </Button>
              )}

              {taskType === "UPDATE" && (
                <Button
                  disabled={!validDDCentry}
                  onClick={updateDDCtable}
                  variant="contained"
                  sx={{
                    width: "50%",
                    fontWeight: 500,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 1,
                    },
                  }}
                >
                  UDPATE DDC RECORD
                </Button>
              )}
            </Box>
          )}

          {!updateLoading && statusMessage === "SUCCESS" && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                textAlign: "center",
                alignItems: "center",
                gap: 2,
              }}
            >
              <CheckCircleIcon color="primary" fontSize="large" />
              <Typography>REQUEST SUCCESS</Typography>
            </Box>
          )}

          {!updateLoading && statusMessage === "ERROR" && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                textAlign: "center",
                alignItems: "center",
                gap: 2,
              }}
              className="text-red-500"
            >
              <ErrorIcon color="error" fontSize="large" />
              <Typography>UNABLE TO COMPLETE REQUEST</Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}
